import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import { getDeviceTag, getDeviceTagChildren, getDeviceTags } from "@/api/resources/deviceTags/api";
import i18n from "@/providers/i18n";

const entity = i18n.t("device-tag");
const entityErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entity }),
};
const entities = i18n.t("device-tags");
const entitiesErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entities }),
};

export const deviceTagsQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "deviceTags"],
  lists: () => [...deviceTagsQueryKeys.all(), "list"],
  listAll: () => [...deviceTagsQueryKeys.lists(), "all"],
  listChildren: (workspace_ids: string[], device_tag_id?: string) => [
    ...deviceTagsQueryKeys.lists(),
    "children",
    workspace_ids,
    device_tag_id,
  ],
  byId: (id?: string) => [...deviceTagsQueryKeys.all(), "byId", id],
};
export const deviceTagsQueries = {
  listAll: () =>
    queryOptions({
      queryKey: [...deviceTagsQueryKeys.listAll()],
      queryFn: () => getDeviceTags(),

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  listChildren: (workspace_ids: string[], device_tag_id?: string) =>
    queryOptions({
      queryKey: [...deviceTagsQueryKeys.listChildren(workspace_ids, device_tag_id)],
      queryFn: () => getDeviceTagChildren(workspace_ids, device_tag_id),
      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  byId: (id?: string) =>
    queryOptions({
      queryKey: [...deviceTagsQueryKeys.byId(id)],
      queryFn: id ? () => getDeviceTag({ match: { id } }) : skipToken,

      meta: {
        errorMessage: entityErrorMessage,
      },
    }),
};
